import React, { useState, useEffect } from "react";
import {
  Center,
  Box,
  Flex,
  Image,
  Checkbox,
  HStack,
  Divider,
  Button,
} from "@chakra-ui/react";
import Granim from "granim";
import "./AppPage.css";
import ConnectButton from "../components/ConnectButton";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { Navigate, Link } from "react-router-dom";

const AppPage = () => {
  const { publicKey, connecting, connected } = useWallet();

  useEffect(() => {
    new Granim({
      element: "#logo-canvas",
      direction: "top-bottom",
      opacity: [1, 1],
      states: {
        "default-state": {
          gradients: [
            ["#000000", "#000000"],
            ["#DC1FFF", "#000000"],
            ["#03E1FF", "#000000"],
            ["#00FFA3", "#000000"],
          ],
          transitionSpeed: 10000,
        },
      },
    });
  }, []);

  return (
    <>
      <>
        <div className="stuff">
          <canvas id="logo-canvas"></canvas>
          <div className="center-content">
            <div>
              {connected ? (
                /*     <Link to="/app"  /> */

                <Link
                  state={{ data: String(publicKey) }}
                  to="/app"
                  _hover={{ textDecoration: "none" }}
                >
                  <Button size="sm" borderRadius="10px">
                    Enter App
                  </Button>
                </Link>
              ) : (
                <ConnectButton />
              )}
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default AppPage;
